import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import DocUrls from '../../../util/doc_urls';

type QueuesPageHeaderProps = {
  onCreateQueue: () => void;
  showCreateQueueButton: boolean;
};

export const QueuesPageHeader = ({
  onCreateQueue,
  showCreateQueueButton,
}: QueuesPageHeaderProps) => {
  return (
    <div className="flex items-center py-16">
      <div className="text-2xl leading-10 font-semibold text-grey-800">
        Launch
      </div>
      <div className="flex-1" />
      <TargetBlank href={DocUrls.launch}>
        <div className="mr-8">
          <Button size="large" variant="secondary" icon="documentation">
            Documentation
          </Button>
        </div>{' '}
      </TargetBlank>
      {showCreateQueueButton && (
        <>
          <Button
            data-test="create-queue"
            size="large"
            variant="primary"
            icon="add-new"
            onClick={onCreateQueue}>
            Create a queue
          </Button>
        </>
      )}
    </div>
  );
};
